// This file contains the application version information
// It will be updated automatically by GitHub Actions

export const VERSION = {
  number: '1.0.112',
  buildDate: '2025-06-19T04:56:52Z',
  commitHash: 'ec3c2514ec6959a1f3990f9c63399d8122b2d127',
}

export const getVersionString = () => {
  return `v${VERSION.number} (${VERSION.commitHash.substring(0, 7)})`
}
